exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.previous-step__container[data-v-5fcf9e9e]{margin-top:30px;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media (max-width: 767px){\n.previous-step__container[data-v-5fcf9e9e]{-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left\n}\n}\n.previous-step__link[data-v-5fcf9e9e]{font-family:\"Encode Sans\";font-size:15px;color:#0293d6\n}\n.previous-step__link[data-v-5fcf9e9e]:hover{cursor:pointer\n}\n.previous-step__link[data-v-5fcf9e9e]::before{display:inline-block;content:url(\"/images/link-icon.svg\");width:22px;height:22px;-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(183deg) translateY(-5px);transform:rotate(183deg) translateY(-5px);margin-right:0.5rem\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fcf9e9e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/valuation-tool/components/Sections/StepLink.vue
// module id = jDYb
// module chunks = 1 2 4 5 15 17 18 19